import {
	Autocomplete,
	AutocompleteRenderInputParams,
	TextField,
	createFilterOptions,
} from "@mui/material";
import { isNil } from "lodash-es";
import React, { useState, useEffect, FC } from "react";

export interface AutocompleteWithSuggestionsProps {
	options: string[];
	value: string | null;
	onChange: (value: string | null) => void;
	label?: string;
	className?: string;
}

export const AutocompleteWithSuggestions: FC<
	AutocompleteWithSuggestionsProps
> = ({ options, value, onChange, label = "", className = "" }) => {
	const [inputValue, setInputValue] = useState<string>(value || "");
	const filter = createFilterOptions<string>();

	useEffect(() => {
		setInputValue(value || "");
	}, [value]);

	const filterOptions = (opts: string[], params: any) => {
		const filtered = filter(opts, params);
		const typed = params.inputValue;
		if (typed && filtered.indexOf(typed) === -1) {
			filtered.unshift(typed);
		}
		return filtered;
	};

	return (
		<Autocomplete
			freeSolo
			options={options}
			value={value}
			inputValue={inputValue}
			filterOptions={filterOptions}
			onInputChange={(_, newInput, reason) => {
				setInputValue(newInput);
				if (reason === "clear") onChange(null);
			}}
			onChange={(_, newValue) => {
				onChange(!newValue || newValue === "" ? null : (newValue as string));
			}}
			autoHighlight
			clearOnEscape
			renderInput={(params: AutocompleteRenderInputParams) => {
				const { InputProps, inputProps: origInputProps, ...rest } = params;
				const castedInputProps =
					origInputProps as React.InputHTMLAttributes<HTMLInputElement>;

				return (
					<TextField
						{...rest}
						InputProps={InputProps}
						inputProps={{
							...castedInputProps,
							onBlur: (e) => {
								castedInputProps.onBlur?.(
									e as React.FocusEvent<HTMLInputElement>,
								);

								if (!inputValue) {
									onChange(null);
								} else {
									if (inputValue !== value) {
										onChange(inputValue);
									}
								}
							},
						}}
						label={label}
						variant="outlined"
						fullWidth
						size="small"
						className={className}
					/>
				);
			}}
		/>
	);
};
